import { ReactNode } from 'react'
import styled from 'styled-components'
import { CreationToolSourceFile } from '../../../types'
import CreationToolFileType from '../../../types/file-type'
import { SourceEditorEdits } from '../../source-editor/types'
import Canvas from './canvas'
import Image from './image'
import Video from './video'

const Media = styled.div`
    border-radius: inherit;
    height: 0;
    overflow: hidden;
    position: relative;
    width: 100%;
`

const Crop = styled.div`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    children?: ReactNode
    overlay?: ReactNode
    source: CreationToolSourceFile
    edits?: SourceEditorEdits
    isMuted?: boolean
    isPlaying?: boolean
    onTimeUpdate?: (currentTime: number) => void
}

const CreationSourcePlayerMedia = ({
    className,
    children,
    overlay,
    source,
    edits,
    isMuted = true,
    isPlaying = true,
    onTimeUpdate,
}: Props) => {
    const aspectRatio = edits?.crop ? edits.crop.height / edits.crop.width : source.height / source.width
    const paddingBottom = `${Math.round(aspectRatio * 100)}%`
    const cropStyles = edits?.crop
        ? {
              left: `${-(edits.crop.x / edits.crop.width) * 100}%`,
              top: `${-(edits.crop.y / edits.crop.height) * 100}%`,
              height: `${(source.height / edits.crop.height) * 100}%`,
              width: `${(source.width / edits.crop.width) * 100}%`,
          }
        : undefined

    const getMedia = () => {
        const isVideo = CreationToolFileType.isVideo(source.type)

        if (source.frames.length) {
            return <Canvas {...{ source, edits, isPlaying, onTimeUpdate }} />
        }

        if (isVideo) {
            return <Video {...{ source, edits, isMuted, isPlaying, onTimeUpdate }} />
        }

        return <Image {...{ source, edits }} />
    }

    return (
        <Media className={className} style={{ paddingBottom }}>
            <Crop style={cropStyles}>
                {getMedia()}
                {overlay}
            </Crop>
            {children}
        </Media>
    )
}

export default CreationSourcePlayerMedia
